// GameRates.js
import React from "react";
import "./GameRates.css";
import { useSelector } from "react-redux";
import { useT } from "../i18n";
const GameRates = () => {

  const { game_results } = useSelector((state) => state.users);
  const { t } = useT();

//   const rates = [
//     { category: "Single Digit", ratio: "10 KA 95" },
//     { category: "Jodi", ratio: "10 KA 950" },
//     { category: "Single Panna", ratio: "10 KA 1400" },
//     { category: "Double Panna", ratio: "10 KA 2800" },
//     { category: "Tripple Panna", ratio: "10 KA 7000" },
//     { category: "Half Sangam", ratio: "10 KA 10000" },
//     { category: "Full Sangam", ratio: "10 KA 100000" },
//   ];

  return (
    <div className="info-screen">
      <div className="info-card">
        <h2>{t('Game Rates')}</h2>
        <p className="info-sub">{t("Main game win ratio for all bids")}</p>
        <ul className="rate-list">
          {game_results?.map((rate, index) => (
            <li key={index}>
              <span>{t(rate.type)}</span>
              <strong>{t('{min} KA {max}',{min:rate.min_value,max:rate.max_value})}</strong>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GameRates;
